import { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

/**
 * A Duolingo option control: a raised row sitting on a 4px bottom border that
 * collapses on press. The native input stays hidden so the whole row is the
 * hit target and still submits as a form field.
 */
export default function DuoOptionRow({
  className,
  inputType,
  leading,
  name,
  onChange,
  selected,
  subtitle,
  title,
  trailing,
  value,
}: {
  className?: string
  inputType: 'checkbox' | 'radio'
  leading?: ReactNode
  name: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  selected: boolean
  subtitle?: string
  title: string
  trailing?: ReactNode
  value: string
}) {
  return (
    <label
      className={twMerge(
        'duo-option',
        selected && 'duo-option-selected',
        className,
      )}
    >
      <input
        checked={selected}
        className="sr-only"
        name={name}
        onChange={onChange}
        type={inputType}
        value={value}
      />

      {leading}

      <span className="flex grow flex-col">
        <span>{title}</span>

        {subtitle && (
          <span
            className={twMerge(
              'text-sm font-medium',
              selected ? 'text-duo-primary' : 'text-duo-muted',
            )}
          >
            {subtitle}
          </span>
        )}
      </span>

      {trailing}
    </label>
  )
}
